import React, { Component } from 'react'
import { Hero } from '../../components/Layout'
import { ProfileForm, PasswordForm } from './components'

export default class extends Component {
  render () {
    const { user, updateUser, updateUserPassword } = this.props

    return (
      <div className='app__content'>
        <div className='content__hero'>
          <Hero heading='Personal settings' />
        </div>
        <div className='content__page'>
          <div className='container'>
            <div className='page'>
              <div className='page-settings page__settings'>
                <ProfileForm
                  user={user}
                  updateUser={updateUser} />

                <PasswordForm
                  user={user}
                  updateUserPassword={updateUserPassword} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Settings/Settings.jsx